export default __webpack_public_path__ + "static/case-4-hero-31fbd1386879dcf14f860c69947e5186.png";